<div class="card fav-images" [class.shrink]="!isExpanded" [class.show]="favImages?.length > 0">
  <div class="cdk-virtual-scroll-data-source">
    <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="80" class="viewport">
      <div *cdkVirtualFor="let favImage of favImages; let i = index"
        class="item">
        <img [src]="favImage.link + '.small.JPG'" style="width: 100%;">
        <div class="btn-container">
          <a (click)="showCarousel(i)"><i class="icon-clusters"></i></a>
          <a [href]="favImage.link" download target="_blank"><i class="icon-download"></i></a>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
  <button class="btn btn-sm btn-light close-carousel" (click)="closeFavImage()">{{'Close' | translate}}</button>
</div>

<ng-template #carousel>
  <div class="carousel-container">
    <carousel (activeSlideChange)="onNavCarousel($event)" [interval]="0" [showIndicators]="true"
      [activeSlide]="currentSlide" [noWrap]="true">
      <slide *ngFor="let favImage of favImages; let i = index; trackById">
        <div class="marker" [style.left]="((favImage.x * (640/3000)) - 20).toFixed(0) + 'px'"
          [style.top]="((favImage.y * (640/3000)) - 20).toFixed(0) + 'px'"></div>
        <img [src]="favImage.link" alt="image slide" style="display: block; height: 40em;">
      </slide>
    </carousel>
  </div>
</ng-template>
<div class="card" cdkDrag [class.expand]="isExpanded" [class.shrink]="!isExpanded">
  <div class="card-body">
    <div class="header">
      <div class="title-container" cdkDragHandle>
        <div class="title text-left">
          <app-breadcrumb></app-breadcrumb>
          <h4 class="text-ellipsis m-0" *ngIf="isExpanded; else smallTitle">{{title}}</h4>
          <ng-template #smallTitle>
            <div class="d-flex flex-column overflow-hidden text-title">
              <p class="text-ellipsis m-0">{{title}}</p>
              <p class="text-ellipsis m-0 text-muted">{{description}}</p>
            </div>
            <div class="d-flex flex-column overflow-hidden text-coor" *ngIf="coordinate">
              <p class="text-ellipsis m-0"><span class="text-muted">lat:</span> {{coordinate[1]}}</p>
              <p class="text-ellipsis m-0"><span class="text-muted">lng:</span> {{coordinate[0]}}</p>
            </div>
          </ng-template> 
        </div>
        <button *ngIf="redirectRoute && isExpanded" class="btn btn-sm btn-primary" [routerLink]="redirectRoute">{{ redirectLabel }}</button>
        <a *ngIf="csvData && isExpanded" csvLink [data]="csvData" class="btn btn-sm btn-primary" style="margin-left: 10px;">{{ exportLabel }}</a>
      </div>
      <ng-container *ngIf="hasAction">
        <div class="action-btn">
          <!-- <a class="btn btn-sm btn-circle btn-outline-primary">
            <i class="icon-search"></i>
          </a> -->
          <a class="btn btn-sm btn-circle btn-outline-primary" routerLink="/projects">
            <i class="icon-close"></i>
          </a>
        </div>
      </ng-container>
      <ng-container *ngIf="hasAvatar && isExpanded">
        <div class="avatar" [style.backgroundImage]="avatar">
          <div class="overlay">
            <input type="file" class="custom-file-input" (change)="onUploadAvatar($event)">
            <div class="btn btn-sm btn-secondary">{{ 'Upload' | translate }}</div>
          </div>
        </div>
      </ng-container>
      <div class="action-btn ml-1" *ngIf="isShowTable">
        <a class="btn btn-sm btn-circle btn-outline-primary btn-tool" (click)="tableButton()" data-cy="tableListButton">
          <i class="icon-calendar"></i>
          <span class="tooltip-text" style="margin-top: -2.7em; margin-left: -3.5em">{{'Table List' | translate}}</span>
        </a>
      </div>
      <div class="action-btn ml-1">
        <a class="btn btn-sm btn-circle btn-outline-primary" (click)="toggleExpand()" data-cy="rightMenuButton">
          <i [class]="isExpanded ? 'icon-minimize' : 'icon-maximize'"></i>
        </a>
      </div>
    </div>
    <div class="card-medium-content" [style.opacity]="isExpanded ? '1':'0'" [style.pointerEvents]="isExpanded ? 'auto':'none'">
      <ng-content></ng-content>
    </div>
  </div>
</div>
